var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient, computedFrom, customElement } from "aurelia-framework";
import { BaseChooseTickets } from "../../templates/base-choose-tickets";
import { ClientLotteryClientService } from "../../../../services/modules/client/client-lottery-client-service";
import { GamePlayerTicketClientService } from "../../../../services/modules/client/client-game-player-ticket-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { EventAggregator } from "aurelia-event-aggregator";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import moment from 'moment';
import { FormatterHelper } from "../../../../helpers/numbers-helper";
import * as Enumerable from "linq";
import { MobileHelper } from "../../../../helpers/mobile-helper";
var ChooseTickets = /** @class */ (function (_super) {
    __extends(ChooseTickets, _super);
    function ChooseTickets(router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18N, lotteryClientService, eventAggregator, dialogClientService, element) {
        return _super.call(this, router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18N, lotteryClientService, eventAggregator, dialogClientService, element) || this;
    }
    ChooseTickets.prototype.getTicketsPerLine = function () {
        return 4;
    };
    Object.defineProperty(ChooseTickets.prototype, "date", {
        get: function () {
            if (!this.lottery) {
                return "";
            }
            var drawTime = moment.utc(this.lottery.drawDate, "YYYY-MM-DD HH:mm");
            var local = drawTime.local();
            //set draw time to lottery draw date
            var dateWithDrawTime = new Date(this.lottery.drawDate);
            if (local) {
                dateWithDrawTime.setHours(local.hours());
                dateWithDrawTime.setMinutes(local.minutes());
            }
            var milliseconds = new Date(dateWithDrawTime).getTime() - new Date().getTime();
            var seconds = Math.floor((milliseconds / 1000) % 60);
            var minutes = Math.floor((milliseconds / 1000 / 60) % 60);
            var hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
            var days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
            if (days < 0) {
                //when date is smaller then 0 ex -0.5 we need to do math.ceil otherwise it will change it to -1 and a day still has not passed
                days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
            }
            var str = '';
            if (days)
                str += "".concat(days, "days");
            if (hours || days)
                str += " ".concat(hours, "hrs");
            if (minutes || hours || days)
                str += " ".concat(minutes, "mins");
            return str;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChooseTickets.prototype, "prize", {
        get: function () {
            if (this.lottery) {
                return FormatterHelper.getformattedValue(this.lottery.totalJackpot, navigator.language, 2);
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    ChooseTickets.prototype.onLotteryDetailsLoaded = function () {
        var _this = this;
        var tickets = Enumerable.from(this.tickets)
            .count(function (x) { return _this.getRemainingBonus(x) == 0 && _this.getRemainingMain(x) == 0; });
        if (MobileHelper.isMobileDevice() && !this.cartGuid && tickets == 0) {
            this.pickOne();
            this.pickOne();
            this.pickOne();
            this.pickOne();
        }
    };
    __decorate([
        computedFrom("lottery"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ChooseTickets.prototype, "date", null);
    __decorate([
        computedFrom("lottery"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ChooseTickets.prototype, "prize", null);
    ChooseTickets = __decorate([
        autoinject,
        transient(),
        customElement('choose-tickets'),
        __metadata("design:paramtypes", [Router, TokenClient, GamePlayerTicketClientService, BindingSignaler,
            NotificationClientService, I18N, ClientLotteryClientService, EventAggregator,
            DialogClientService, Element])
    ], ChooseTickets);
    return ChooseTickets;
}(BaseChooseTickets));
export { ChooseTickets };
